import RegionDrag from './RegionDrag';

export default RegionDrag;
